import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { DocRenewConfigInfoController } from '../../models/docs/doc.model';


@Pipe({
  name: 'DocRenewConfigFilter'
})

@Injectable()
export class DocRenewConfigPipe implements PipeTransform {

  transform(value: DocRenewConfigInfoController[], filter: string): DocRenewConfigInfoController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: DocRenewConfigInfoController) =>
      app.AlertLevelLongValue != null && app.AlertLevelLongValue.toLocaleLowerCase().indexOf(filter) != -1
      || app.AlertBeforeDays != null && app.AlertBeforeDays.toString().indexOf(filter) != -1
      || app.CredentialTypeGroup != null && app.CredentialTypeGroup.toLocaleLowerCase().indexOf(filter) != -1
      || app.RenewalDurationDays != null && app.RenewalDurationDays.toString().indexOf(filter) != -1

    ) : value;
  }

}
